"use client"

import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import type { LeaderboardData } from "@/types/leaderboard"
import LeaderboardClient from "./leaderboard-client"

interface AnimatedLeaderboardProps {
  initialData: LeaderboardData
}

export function AnimatedLeaderboard({ initialData }: AnimatedLeaderboardProps) {
  const [isVisible, setIsVisible] = useState(false)

  // Force animations to run on mount
  useEffect(() => {
    setIsVisible(true)
  }, [])

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight font-funnel">Leaderboard</h1>
          <p className="text-gray-600">Discover who has the highest totem.</p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      >
        <div className="w-full">
          <LeaderboardClient initialData={initialData} />
        </div>
      </motion.div>
    </>
  )
}
